<template>
    <b-col class="col-center pl-1 pr-1 block-content"  lg="3" md="12"  cols="12"  v-if="content">
        <b-row align-h="center">
            <p  class="mt-5 block-titulo" v-html="content.titulo">  </p>
        </b-row>
       <b-row align-h="center">
           <img :src="srcImagen" class="block-img" alt="">
       </b-row>
       <b-row align-h="center">
           <p class="block-text-content" v-html="content.subtitulo"> </p>
       </b-row>
    </b-col>
</template>
<script>
    export default {
        name: 'Block',
        props: {
            content: Object
        },
        computed: {
            srcImagen() {
                let src = require('@/assets/images/' + this.content.imagen)
                return src
            }
        }
    }
</script>
<style scoped>
</style>